import UpdatePasswordGeneric from '../UpdatePasswordGeneric';

const UpdatePasswordMedico = () => {
    return (
        <UpdatePasswordGeneric
            verifyTokenRoute="/area-medico/reset-password/verify-token"
            changePasswordRoute="/area-medico/reset-password/change-password"
            loginRoute="/AreaMedico/login"
        />
    );
};

export default UpdatePasswordMedico;
